import Data from "../../data.json";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import iconSource from "../../assets/icon-source.svg";
import "./Planet.css";
import LoadingIcon from "../../assets/planet-earth.svg";
const Planet = (props) => {
  const [planet, setPlanet] = useState();
  const [isInView, setIsInView] = useState();

  useEffect(() => {
    const filteredData = Data.filter(
      (planet) => planet.name === props.planetName
    );
    setPlanet(filteredData[0]);
    setIsInView("overview");
  }, [props.planetName, props.view]);

  if (!planet) {
    return (
      <div className="loading">
        <motion.img
          animate={{ rotate: 360 }}
          transition={{ ease: "linear", duration: 2, repeat: Infinity }}
          src={LoadingIcon}
        />
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div className="planet wrapper">
      <div className="main-content">
        <div className="box-1 flex-center">
          {isInView === "overview" && (
            <motion.img
              src={planet.images.planet}
              initial={{ scale: 0, y: 100 }}
              animate={{ rotate: 180, scale: 1, y: 0 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            />
          )}
          {isInView === "structure" && (
            <motion.img
              src={planet.images.internal}
              initial={{ scale: 0, y: 100 }}
              animate={{ rotate: 180, scale: 1, y: 0 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            />
          )}
          {isInView === "geology" && (
            <motion.img
              src={planet.images.planet}
              initial={{ scale: 0, y: 100 }}
              animate={{ rotate: 180, scale: 1, y: 0 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            />
          )}
          {isInView === "geology" && (
            <motion.img
              src={planet.images.geology}
              initial={{ scale: 0 }}
              animate={{ rotate: 180, scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            />
          )}
        </div>
        <div className="box-2">
          <h1>{planet.name}</h1>
          {isInView === "overview" && <p>{planet.overview.content}</p>}
          {isInView === "structure" && <p>{planet.structure.content}</p>}
          {isInView === "geology" && <p>{planet.geology.content}</p>}
          <span>
            Source:
            <Link className="link" to={planet.overview.source}>
              Wikipedia
              <img className="icon-source" src={iconSource} />
            </Link>
          </span>
          <div className="overview-buttons">
            <motion.button
              className={isInView === "overview" ? props.planetName : "btn"}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
              onClick={() => setIsInView("overview")}
            >
              01 Overview
            </motion.button>
            <motion.button
              className={isInView === "structure" ? props.planetName : "btn"}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
              onClick={() => setIsInView("structure")}
            >
              02 Internal Structure
            </motion.button>
            <motion.button
              className={isInView === "geology" ? props.planetName : "btn"}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
              onClick={() => setIsInView("geology")}
            >
              03 Surface Geology
            </motion.button>
          </div>
        </div>
        <div className="box-3 flex-center">
          <div className="grid-tags">
            <div className="rotation-time">
              <h2>ROTATION TIME</h2>
              <span>{planet.rotation}</span>
            </div>
            <div className="revolution-time">
              <h2>REVOLUTION TIME</h2>
              <span>{planet.revolution}</span>
            </div>
            <div className="radius">
              <h2>RADIUS</h2>
              <span>{planet.radius}</span>
            </div>
            <div className="average-temp">
              <h2>AVERAGE TEMP</h2>
              <span>{planet.temperature}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Planet;

// import Data from "../../data.json";
// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import iconSource from "../../assets/icon-source.svg";
// import "./Planet.css";

// const Planet = (props) => {
//   const [planet, setPlanet] = useState();
//   const [isInView, setIsInView] = useState("overview");

//   useEffect(() => {
//     const filteredData = Data.filter(
//       (planet) => planet.name === props.planetName
//     );
//     setPlanet(filteredData[0]);
//     setIsInView("overview");
//   }, [props.planetName]);

//   if (!planet) {
//     return <div>Loading...</div>;
//   }

//   let componentToRender;
//   switch (isInView) {
//     case "overview":
//       componentToRender = (
//         <>
//           <div className="box-1 flex-center">
//             <img src={planet.images.planet} />
//           </div>
//           <div className="box-2">
//             <h1>{planet.name}</h1>
//             <p>{planet.overview.content}</p>
//             <span>
//               Source:
//               <Link className="link" to={planet.overview.source}>
//                 Wikipedia
//                 <img className="icon-source" src={iconSource} />
//               </Link>
//             </span>
//             <div className="overview-buttons">
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("overview")}
//               >
//                 01 Overview
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("structure")}
//               >
//                 02 Internal Structure
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("geology")}
//               >
//                 03 Surface Geology
//               </button>
//             </div>
//           </div>
//         </>
//       );
//       break;
//     case "structure":
//       componentToRender = (
//         <>
//           <div className="box-1 flex-center">
//             <img src={planet.images.internal} />
//           </div>
//           <div className="box-2">
//             <h1>{planet.name}</h1>
//             <p>{planet.structure.content}</p>
//             <span>
//               Source:
//               <Link className="link" to={planet.overview.source}>
//                 Wikipedia
//                 <img className="icon-source" src={iconSource} />
//               </Link>
//             </span>
//             <div className="overview-buttons">
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("overview")}
//               >
//                 01 Overview
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("structure")}
//               >
//                 02 Internal Structure
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("geology")}
//               >
//                 03 Surface Geology
//               </button>
//             </div>
//           </div>
//         </>
//       );
//       break;
//     case "geology":
//       componentToRender = (
//         <>
//           <div className="box-1 flex-center">
//             <img src={planet.images.planet} />
//             <img src={planet.images.geology} />
//           </div>
//           <div className="box-2">
//             <h1>{planet.name}</h1>
//             <p>{planet.geology.content}</p>
//             <span>
//               Source:
//               <Link className="link" to={planet.overview.source}>
//                 Wikipedia
//                 <img className="icon-source" src={iconSource} />
//               </Link>
//             </span>
//             <div className="overview-buttons">
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("overview")}
//               >
//                 01 Overview
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("structure")}
//               >
//                 02 Internal Structure
//               </button>
//               <button
//                 className={props.planetName}
//                 onClick={() => setIsInView("geology")}
//               >
//                 03 Surface Geology
//               </button>
//             </div>
//           </div>
//         </>
//       );
//       break;
//   }

//   return (
//     <div className="planet wrapper">
//       <div className="main-content">
//         {componentToRender}
//         <div className="box-3 flex-center">
//           <div className="grid-tags">
//             <div className="rotation-time">
//               <h2>ROTATION TIME</h2>
//               {planet.rotation}
//             </div>
//             <div className="revolution-time">
//               <h2>REVOLUTION TIME</h2>
//               {planet.revolution}
//             </div>
//             <div className="radius">
//               <h2>RADIUS</h2>
//               {planet.radius}
//             </div>
//             <div className="average-temp">
//               <h2>AVERAGE TEMP</h2>
//               {planet.temperature}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Planet;
